var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        "close-on-click-modal": false,
        title: _vm.title,
        width: "1000px",
        "custom-class": "main-content"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: function($event) {
          return _vm.cancel(0)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c(
            "el-tabs",
            {
              attrs: { "active-name": _vm.activeLable, type: "card" },
              on: { "tab-click": _vm.handleClick }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_ViewPaymentRequest"),
                    name: "applicationForm"
                  }
                },
                [
                  _c("application-form", {
                    ref: "applicationForm",
                    staticStyle: { width: "100%" },
                    attrs: {
                      "open-sap-config": _vm.openSapConfig,
                      "bill-payment-uuid": _vm.billPaymentUuid,
                      "params-final": _vm.state,
                      "params-charges": _vm.charges,
                      "charges-dirty": _vm.chargesDirty,
                      "bill-payment-dirty": _vm.billPaymentDirty,
                      "parent-context": _vm.parentContext,
                      location: _vm.location
                    },
                    on: {
                      cancel: function($event) {
                        return _vm.cancel($event)
                      },
                      toPreStep: _vm.toPreStep
                    }
                  })
                ],
                1
              ),
              _vm.state != -1
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_FileHistory"),
                        lazy: true,
                        name: "fileHistory"
                      }
                    },
                    [
                      _c("file-history", {
                        attrs: {
                          "bill-payment-uuid": _vm.billPaymentUuid,
                          "bill-payment-state": _vm.fileState,
                          "input-by": _vm.inputBy,
                          "upload-enable": _vm.viewSource == "tabBilling"
                        },
                        on: {
                          reloadData: function($event) {
                            return _vm.reloadData($event)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.state != -1
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_ApprovalHistory"),
                        lazy: true,
                        name: "approvalList"
                      }
                    },
                    [
                      _c("approval-history", {
                        staticStyle: { width: "100%" },
                        attrs: { "bill-payment-uuid": _vm.billPaymentUuid }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }